<template>
    <nav class="navbar px-4 py-2" v-if="!(inIframe && isSiteMsa)">
        <div class="container">
            <a class="navbar-brand text-white fw-bold" href="/home">
                <img id="logo" :src="fo_config['logo']" alt="logo">
            </a>
            <div class="d-flex gap-3" v-if="allowSignIn && !this.redirected">
                <div class="">
                    <button
                        :href="'/profile'"
                        class="btn-log"
                        @click="this.$inertia.get('/profile')"
                        v-if="user && allowSignIn">
                        {{ this.redirected ? this.account_title : "Mon compte"}}
                    </button>
                </div>
                <div class="">
                    <!-- <button
                    class="btn-log"
                    @click="toggleModal('#auth-modal')"
                    id="auth-button"
                    v-if="!user && withAuth"
                    >
                    Je m'authentifie
                    </button> -->
                    <button class="btn-log" v-if="user" @click="logout">
                        Me déconnecter
                    </button>
                </div>
            </div>
            <div class="navbar-item"  v-if="this.redirected">
                <div class="buttons">
                    <a class="button is-danger" @click="cancel_redirect_rdv()">{{ this.fo_config['text']['RDV_BY_REDIRECT_btn_cancel'] }}</a>
                </div>
            </div>
        </div>
    </nav>        
</template>

<script>
import { Inertia } from "@inertiajs/inertia";
import axios from 'axios'
import { Link } from "@inertiajs/inertia-vue3";
import AuthModal from "../Profile/AuthModal.vue";
import { toast } from "bulma-toast";
// import logoURL from "../../../../../public/assets/images/msa-logo-white.png"

export default {
    name: 'HeaderLayout',
    props: ["settingsConfig","config","fo_config", "account_title"],
    components: { AuthModal, Link },
    emits: ['submitWithoutAuth'],
    computed: {
        allowSignIn() {
        return !this.$page.props.config?.disabled_fo_signin;
        },
        inIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            console.log(e);
            return true;
        }
        },
        isSiteMsa() {
        return document.location.hostname === "teammsa.prordv.com";
        },
        logo() {
        return this.$page.props.logo;
        },
        slogan() {
        return this.$page.props.slogan;
        },
        hostname() {
        return window.location.hostname;
        },
        user() {
        return this.$page.props.auth.user?.client?.[0];
        },
        withAuth(){
            return !(this.settingsConfig && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] == 1);
        },
        autoBooking(){
            return (this.settingsConfig && this.settingsConfig["AUTO_BOOKING"] && this.settingsConfig["AUTO_BOOKING"] == 1);
        },
        redirected(){
        return this.fo_config && (this.fo_config['redirected'] == 1);
        },
        redirect_params(){
        if(!this.redirected){
            return '';
        }    

        let params = new URLSearchParams(window.location.search);
        params.delete('rdv_id');
        params.delete('redirected');
        return '?'+params+'&redirected=1';
        },    
    },
    methods: {
        logout() {
            axios.get('/auth/logout').then((response) => {
                // this.$inertia.get("/auth/logout");
                window.location.href = "/booking"
            });
        },
        toggleModal(id) {
        let modal = document.querySelector(id);
        modal.classList.toggle("is-active");
        },
        toggleMenu() {
        let navbar_burger = document.querySelector(".navbar-burger");
        navbar_burger.classList.toggle("is-active");
        let menu = document.querySelector(".navbar-menu");
        menu.classList.toggle("is-active");
        },
        onUserLogin() {
        Inertia.reload({ only: ["auth.user"] });
        console.log('user',this.user);
        },
        get_redirected_params(){
        if(!this.redirected){
            return null;
        }

        let all_params = new URLSearchParams(window.location.search);
        let params = all_params.get('all_params_redirect');
        if(params != null){
            return JSON.parse(atob(params));
        }
        return null;
        },
        redirect(id_container, form) {
            console.log('in redirect');
            
            let container = document.getElementById(id_container);
            console.log('container',container,form);
            
            container.insertAdjacentHTML('afterbegin',form);
            let redirect_form = document.getElementById('rdv_redirect_form');
            redirect_form.submit();

            console.log('redirect element',redirect_form);
            
        },
        cancel_redirect_rdv(){
            if(this.redirected){
                let data = {};
                let params = this.get_redirected_params();
                console.log('cancel_redirect_rdv params',params);
                
                if(typeof params == 'object'){
                data.reservation_statut = 'ABANDON';
                data.ext_prestation_id = params.ext_prestation_id;
                
                if(typeof params.cancel_url == 'string' && params.cancel_url.length > 0) {data.cancel_url = params.cancel_url;}
                console.log('data to get form', data);
                
                axios
                        .post('/redirect/form/cancel',data)
                        .then((response) => {
                            this.redirect('layout_nav',response.data);
                        })
                        .catch((error) => {
                        toast({
                            message: this.$page.props.flash.message,
                            type: "is-danger",
                            duration: 5000,
                            pauseOnHover: true,
                        });
                        });
                }
                else{
                toast({
                        message: 'Paramètres de redirection manquantes',
                        type: "is-danger",
                        duration: 5000,
                        pauseOnHover: true,
                    });
                    this.$inertia.get(this.withAuth ? '/profile' : '/');
                }
            }else{
                this.$inertia.get(this.withAuth ? '/profile' : '/');
            }
        }
    },
    mounted() {
        if (this.$page.props.flash.message && !(this.config && this.config['confirm_web_rdv'] == 1) && !this.redirected) {
        toast({
            message: this.$page.props.flash.message,
            type: "is-success",
            duration: 5000,
            pauseOnHover: true,
        });
        }
    },    
}
</script>

<style>
    #logo{
        max-width: 100px;
        max-height: 40px;
    }
</style>